var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$device.mobile)?_c('div',[_c('MobileGame'),_c('MobileRoad'),_c('MobileInside'),_c('Details'),_c('v-scroll-to-top',{staticClass:"scroll-to-top"})],1):_c('div',[_c('DesktopGame')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }